import { FC } from 'react';
import styled from 'styled-components';
import { colors } from '../../../component/colors';
import Modal from '../../../component/modal/base';
import { ReactComponent as Success } from '../../../assets/success.svg';
import { pxToRem } from '../../../utils/pxToRem';

interface IConfirmModal {
  isLoading?: boolean;
  confirmBtnClick: () => void;
  cancelBtnClick: () => void;
}
export const ConfirmModal: FC<IConfirmModal> = ({
  isLoading,
  confirmBtnClick,
  cancelBtnClick
}) => {
  return (
    <Modal>
      <Container>
        <ModalCard>
          <WarningSymbol>
            <Success />
          </WarningSymbol>
          <DeleteTitle>Verify document</DeleteTitle>
          <DeleteText>
            Are you sure you those details meet the criteria for being verifed,
            if yes procced!
          </DeleteText>
          <DeleteButtonGroup>
            <ConfirmButton
              type={'button'}
              disabled={isLoading}
              onClick={confirmBtnClick}
            >
              {!isLoading ? `Yes, Verify` : `confirming...`}
            </ConfirmButton>
            <CancelButton
              disabled={isLoading}
              type={'button'}
              onClick={cancelBtnClick}
            >
              Cancel
            </CancelButton>
          </DeleteButtonGroup>
        </ModalCard>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  background-color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  padding: 20px 45px;
  text-align: center;
  max-width: 400px;
  height: 290px;
`;
const ModalCard = styled.div``;

const WarningSymbol = styled.p`
  margin: 25px auto;
`;
const DeleteTitle = styled.h5`
  font-weight: 600;
  font-size: ${pxToRem(16)};
  line-height: ${pxToRem(25)};
  color: #27272e;
  margin-bottom: 8px;
`;
const DeleteText = styled.p`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(23)};
  color: #425466;
`;
const DeleteButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;
const ConfirmButton = styled.button`
  border: none;
  background-color: #36ce2a;
  border-radius: 8px;
  color: ${colors.white};
  padding: 12px 25px;
  font-size: ${pxToRem(14)};
  margin: 0 15px;
`;
const CancelButton = styled.button`
  border: none;
  background-color: #fafafa;
  border-radius: 8px;
  color: ${colors.danger};
  padding: 12px 25px;
  font-size: ${pxToRem(14)};
  margin: 0 15px;
`;
